import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

export const sendFormEvent = (
    formId: string,
    values: Record<string, unknown>,
    other: object,
    hasInn = false
) => {
    sendEvent({
        event: 'site_formRequest_send',
        url: window.location.href,
        page: window.document.title,
        company: values.autocompleteCompanyName,
        fio: values.fio,
        inn: values.inn,
        adress: values.location,
        phone: values.phone,
        email: values.email,
        agreement: values.sopdConfirmed as string,
        form_id: formId,
        form_with_inn: hasInn,
        ...other,
    });
};
